import { ApplicationRef, Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { concat, interval } from 'rxjs';
import { first } from 'rxjs/operators';
import { AppConfirmService } from '../services/app-confirm/app-confirm.service';

@Injectable({
    providedIn: 'root'
  })
export class CheckForUpdateService {

  constructor(    private confirmService: AppConfirmService, appRef: ApplicationRef, updates: SwUpdate) {
    const isEnabled = updates.isEnabled;
    console.log(`CheckForUpdateService[SwUpdate=${isEnabled}]`);
    if (isEnabled) {
        // Allow the app to stabilize first, before starting
        // polling for updates with `interval()`.
        const appIsStable$ = appRef.isStable.pipe(first(isStable => isStable === true));
        const hours = 1;
        const everyNHours$ = interval(hours * 60 * 60 * 1000);
        const everyNHoursOnceAppIsStable$ = concat(appIsStable$, everyNHours$);
    
        everyNHoursOnceAppIsStable$.subscribe(async () => {
          try {
            const updateFound = await updates.checkForUpdate();
            console.log(updateFound ? 'A new version is available.' : 'Already on the latest version.');
          } catch (err) {
            console.error('Failed to check for updates:', err);
          }
        });
    }

  }
}